import AIPoweredIcon from "components/svg-icons/ai-powered-icon";

export default function AiPoweredUI(props: { label?: string }) {
  const { label } = props;
  return (
    <div className="flex px-2 py-0.5 text-xs  space-x-1 bg-ciq-golden-purple-1 border border-solid border-ciq-golden-purple-3 text-ciq-golden-purple-6 justify-center items-center rounded">
      <AIPoweredIcon />
      <div>{label || "AI powered"}</div>
    </div>
  );
}
